import calculateNameRank from 'bl/client/calculateNameRank.bl';
import calculateNicknameRank from 'bl/client/calculateNicknameRank.bl';
import calculatePhoneRank from 'bl/client/calculatePhoneRank.bl';
import noNilArray from 'utils/arrays/noNilArray.util';
import fromAnyToNonLeadingZeroText from 'utils/converters/any/fromAnyToNonLeadingZeroText.util';
import fromAnyToSearchableName from 'utils/converters/any/fromAnyToSearchableName.util';
import fromAnyToSearchName from 'utils/converters/any/fromAnyToSearchName.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';
import isMissing from 'utils/predicates/any/isMissing.util';

const L = logger('searchClient'); // eslint-disable-line no-unused-vars

const USE_DEBUG_LOG = false;

const byRankAndName = (a, b) => {
  const rankA = a?.rank - 0;
  const rankB = b?.rank - 0;

  const difference = rankB - rankA;
  if (difference !== 0) return difference;

  const nameA = fromAnyToString(a?.user_name).toLowerCase();
  const nameB = fromAnyToString(b?.user_name).toLowerCase();

  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;

  return 0;
};

const searchClient = (options) => {
  const users = noNilArray(options?.list);
  const text = options?.text;

  const searchText = fromAnyToNonLeadingZeroText(text);
  const isTextPresent = searchText.length > 0;

  const phoneResults = isTextPresent
    ? users
        .filter((u) => (u?.phone ? fromAnyToNonLeadingZeroText(u.phone).indexOf(searchText) !== -1 : false))
        .map((u) => ({ ...u, rank: calculatePhoneRank({ phone: u?.phone, text }) }))
    : [];

  if (phoneResults.length > 0) {
    if (USE_DEBUG_LOG) L.debug('()', 'Phone hit for options:', options, 'returning:', phoneResults);
    return phoneResults;
  }

  const searchString = fromAnyToSearchName(searchText);

  const nameResults = isTextPresent
    ? users
        .filter((u) => fromAnyToSearchableName(u?.user_name).indexOf(searchString) !== -1)
        .map((u) => ({ ...u, rank: calculateNameRank({ name: u?.user_name, text }) }))
    : [];

  const nicknameResults = users
    .filter((u) => fromAnyToSearchableName(u?.known_as).indexOf(searchString) !== -1)
    .map((u) => ({ ...u, rank: calculateNicknameRank({ nickname: u?.known_as, text }) }));

  const filteredNicknameResults = nicknameResults.filter((a) => isMissing(nameResults.find((b) => b?.id === a?.id)));

  const result = nameResults.concat(filteredNicknameResults).sort(byRankAndName);
  if (USE_DEBUG_LOG) L.debug('()', 'Name/nickname results for options:', options, 'returning:', result);

  return result;
};

export default searchClient;
